import { render } from "./AccountBody.vue?vue&type=template&id=76c5da88&scoped=true"
import script from "./AccountBody.vue?vue&type=script&lang=js"
export * from "./AccountBody.vue?vue&type=script&lang=js"

import "./AccountBody.vue?vue&type=style&index=0&id=76c5da88&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c5da88"]])

export default __exports__